import { useSafeAreaInsets } from 'react-native-safe-area-context';

export const useSafeArea = () => {
  return useSafeAreaInsets();
};
